import axios from "axios";
import { URL } from "../../config/config";

const BASE = `${URL}/superadmin/agent-analytics`;
const ACTIONS_BASE = `${URL}/superadmin/agent-analytics-actions`;

// Distinguishes "not deployed yet" (404) from a genuine failure, so callers
// can render the not-available state instead of a blank/empty one.
function normalize(promise) {
  return promise
    .then((res) => ({ data: res.data, notFound: false, error: null, status: res.status }))
    .catch((err) => {
      const notFound = err?.response?.status === 404;
      return {
        data: null,
        notFound,
        status: err?.response?.status,
        error: notFound ? null : errorText(err?.response?.data) || err?.message || "Request failed",
      };
    });
}

// FastAPI errors carry `detail` (string, or a list of validation errors).
function errorText(body) {
  const d = body?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => [(e.loc || []).slice(1).join("."), e.msg].filter(Boolean).join(": ")).join("; ");
  return body?.message;
}

export function fetchFleet(path, params) {
  return normalize(axios.get(`${BASE}/${path}`, { params }));
}

export function postFleetAction(path, body, params) {
  return normalize(axios.post(`${ACTIONS_BASE}/${path}`, body, params ? { params } : undefined));
}
